//@flow
import React from 'react';
import Link from './../../../components/Link';
import LazyLoad from 'react-lazyload';
import ProductBasicInfo from '../../ProductDetails/components/ProductBasicInfo.react';
import AddCartSnackCard from '../../ProductDetails/components/AddCartSnackCard.react';
import ItemQty from '../../ItemQty/components/ItemQty.react';

import imgPlaceholder from '../../../images/catalog/placeholder-product-image.jpg';

import type { List } from 'immutable';
import type ProductModel from '../../Stores/Products/productModel';
import type ProductsCollection from '../../Stores/Products/productsCollection';
import type StockCollection from '../../Stores/Stock/stockCollection';
import type CategoriesCollection from '../../Stores/MemberCategories/categoriesCollection';
import type QuoteItemModel from '../../Stores/Quote/quoteItemModel';
import type CustomerModel from '../../Stores/Customer/customerModel';
import type QuoteModel from '../../Stores/Quote/quoteModel';
import type QuoteTotalsModel from '../../Stores/Quote/quoteTotalsModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';
import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  product:ProductModel,
  products:ProductsCollection,
  quote:QuoteModel,
  quoteItem:?QuoteItemModel,
  quoteTotals:QuoteTotalsModel,
  categories:CategoriesCollection,
  customer?:CustomerModel,
  stockReminders?:List<string>,
  inAlsoLike?:boolean,
  idx:number,
  userCountry:?string,
  stock:StockCollection,
  quoteItems:QuoteItemsCollection,
  hidePrice?:boolean,
  membershipPlan:MembershipPlanModel,
  isOffice?:boolean,
};

export default class Snack extends React.Component<Props> {
  _getImageUrl():string {
    return this.props.product.getSnackcardImageUrl(300,235);
  }

  _getInStock() {
    return this.props.stock.inStock(this.props.product.getSku());
  }

  _getPreSale() {
    return this.props.stock.preSale(this.props.product.getSku());
  }

  _getNotAllowedReasons() {
    const countryCode = this.props.userCountry;
    if (!countryCode || this.props.product.isAllowedInCountry(countryCode)) {
      return undefined;
    }
    return this.props.product.getNotAllowedCountryReasons(countryCode);
  }

  _getItemAddButton() {
    if (this.props.hidePrice || this.props.isOffice) return null;
    return (
      <ItemQty
        className="detail-select"
        quoteItem={this.props.quoteItem}
        quoteId={this.props.quote.getId()}
        sku={this.props.product.getSku()}
        inStock={this._getInStock()}
        preSale={this._getPreSale()}
        displayComponentClass={AddCartSnackCard}
        customer={this.props.customer}
        showOOSView="tooltip"
        stockReminders={this.props.stockReminders}
        inAlsoLike={this.props.inAlsoLike}
        idx={this.props.idx}
        notAllowedReasons={this._getNotAllowedReasons()}
        categories={this.props.categories}
        quoteItems={this.props.quoteItems}
        products={this.props.products}
      />
    );
  }

  render() {
    const product = this.props.product;
    const url = this.props.isOffice
      ? product.getOfficeUrl()
      : product.getUrl();
    return (
      <li className="grid-item snack-card" data-url-key={product.getUrlKey()}>
        <div className="photo-container">
          <Link to={url} external={true}>
            <div className="photo">
              <LazyLoad
                offset={500}
                placeholder={<img src={imgPlaceholder} className="snack-image-placeholder" alt={product.getName()} />
                }
              >
                <img className="snack-image" src={this._getImageUrl()} alt={product.getName()} />
              </LazyLoad>
            </div>
          </Link>
          {this._getItemAddButton()}
        </div>

        <div className="snack-name-container">
          <ProductBasicInfo
            className="snack-name"
            linkToProduct={true}
            product={product}
            categories={this.props.categories}
            quote={this.props.quote}
            quoteTotals={this.props.quoteTotals}
            showPrice={!this.props.hidePrice}
            preSale={this._getPreSale()}
            membershipPlan={this.props.membershipPlan}
            isOffice={this.props.isOffice}
          />
        </div>
      </li>
    );
  }
}
